var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ReactDOM from 'react-dom';
import styles from './Modal.module.scss';
import PropTypes from 'prop-types';
import { CloseDark } from '../../assets/icons';
import { Button } from '../Button/Button';
var ModalComponent = function (_a) {
    var title = _a.title, submitLabel = _a.submitLabel, children = _a.children, primary = _a.primary, danger = _a.danger, warning = _a.warning, confirm = _a.confirm, id = _a.id, dataId = _a.dataId, loading = _a.loading, onCancel = _a.onCancel, onSubmit = _a.onSubmit;
    return (_jsx("section", __assign({ className: styles.ModalWrapper }, { children: _jsxs("section", __assign({ className: styles.Modal, id: id, "data-testid": dataId }, { children: [_jsxs("header", __assign({ className: styles.Header }, { children: [title && _jsx("h3", __assign({ className: styles.Title }, { children: title })), _jsx(CloseDark, { size: 24, className: styles.Close, onClick: onCancel })] })), _jsx("section", __assign({ className: styles.Content }, { children: children })), _jsxs("footer", __assign({ className: styles.Actions, "data-testid": 'modal-actions' }, { children: [!confirm && (_jsx("span", __assign({ className: styles.Cancel, onClick: onCancel, "data-testid": 'modal-cancel' }, { children: "Cancel" }))), onSubmit && (_jsx(Button, { disabled: loading, small: true, title: submitLabel || 'Submit', primary: primary, danger: danger, warning: warning, onClick: onSubmit, "data-testid": 'modal-save' }))] }))] })) })));
};
ModalComponent.propTypes = {
    title: PropTypes.string,
    submitLabel: PropTypes.string,
    primary: PropTypes.bool,
    danger: PropTypes.bool,
    warning: PropTypes.bool,
    confirm: PropTypes.bool,
    id: PropTypes.string,
    dataId: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
};
var Modal = function (props) {
    return _jsx(_Fragment, { children: ReactDOM.createPortal(_jsx(ModalComponent, __assign({}, props)), document.getElementById('modal-root')) });
};
export { Modal };
//# sourceMappingURL=Modal.js.map